// extracted by mini-css-extract-plugin
export default {"storyDetailListWrapper":"c-r_fY","storyDetailListWrapper__title":"c-r_fZ","storyDetailListWrapper__timeline":"c-r_ga","storyDetailListWrapper__list":"c-r_gb"};